import CheckIcon from "@mui/icons-material/Check";
import React from "react";

const CheckList = ({ items }: { items: (string | React.ReactElement)[] }) => {
  return (
    <ul style={{ paddingLeft: 0 }}>
      {items.map((item, idx) => (
        <li key={idx} style={{ marginBottom: "12px", display: "flex", alignItems: "flex-start" }}>
          <CheckIcon style={{ color: "#ff6600", marginRight: "8px", fontSize: "20px" }} />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
};

export { CheckList };
